import { useEffect } from 'react'
import { PressRelease } from './PressRelease'
import { useGetCountryLanguage } from '@hooks/useGetCountryLanguage'
import { usePageVariations } from '@hooks/usePageVariations'
import { APP_FEATURES } from '@constants/features'
import type { PressReleasePageVariationEntries } from '@cms/data/getPressReleaseArticle'
import type { AppLocales } from '@constants/i18n'
import type { UrlsPerCountry } from '@constants/countryDetails'

type PressReleaseLoaderData = {
  pressReleaseArticle: PressReleasePageVariationEntries
  pageVariations: UrlsPerCountry
}

type PressReleaseArticleProps = {
  loaderData: PressReleaseLoaderData
  locale: AppLocales
}

const PressReleaseArticle = ({
  loaderData,
  locale,
}: PressReleaseArticleProps) => {
  const { language } = useGetCountryLanguage()

  const { pageVariations, pressReleaseArticle } = loaderData
  const { setLocalizedUrls } = usePageVariations()

  useEffect(() => {
    setLocalizedUrls(pageVariations)
  }, [pageVariations, setLocalizedUrls])

  const pressReleasesUrl = `${APP_FEATURES.PressReleases.prefix[language]}/1`

  return (
    <PressRelease
      item={pressReleaseArticle}
      locale={locale}
      pressReleasesUrl={pressReleasesUrl}
    />
  )
}

export { PressReleaseArticle }
